import type { ExportAsyncForm } from "./export-async-form";
import type { ExportAsyncHandler } from "./export-async-handler";

/**
 * Intercepts the export form submit and routes it through the async handler
 * (ISS-08-015). If the submit can't be mapped to a card (no submitter, missing
 * status box), it does nothing and the native streaming `formaction` runs — the
 * no-JS fallback.
 */
export class ExportAsyncListener {
    private readonly form: ExportAsyncForm;

    private readonly handler: ExportAsyncHandler;

    public constructor(form: ExportAsyncForm, handler: ExportAsyncHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        this.form.getFormElement().addEventListener("submit", (event) => {
            const submitter = event instanceof SubmitEvent ? event.submitter : null;
            const card = this.form.getCardFromSubmitter(submitter);
            const statusBox = card ? this.form.getStatusBoxInCard(card) : null;
            const entity = statusBox?.dataset.entity ?? "";

            if (!card || !statusBox || entity === "") {
                return;
            }

            event.preventDefault();
            void this.handler.start(entity, statusBox, this.form.getSubmitButtonInCard(card));
        });
    }
}
